/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ID } from '@/data/types/Basic';
import dynamic from 'next/dynamic';
import { ComponentType } from 'react';

export const contentManifestCustom: Record<string, ComponentType<{ id: ID }>> = {
	// Overrides core Bundle component with HDM BDP layout (US: layout & information)
	Bundle: dynamic(() =>
		import('@/components/content/BundleDetails').then((mod) => mod.BundleDetails)
	),
	HdmEmarsysProductRecommendation: dynamic(() =>
		import('@/components/content/HdmEmarsysProductRecommendation').then(
			(mod) => mod.HdmEmarsysProductRecommendation
		)
	),
	HdmAditionalInfo: dynamic(() =>
		import('@/components/content/HdmAditionalInfo').then((mod) => mod.HdmAditionalInfo)
	),
	HdmBazaarrvoiceRQ: dynamic(() =>
		import('@/components/content/HdmBazaarrvoiceRQ').then((mod) => mod.HdmBazaarrvoiceRQ)
	),
	HdmSpecs: dynamic(() => import('@/components/content/HdmSpecs').then((mod) => mod.HdmSpecs)),
	HdmSkucomparer: dynamic(() =>
		import('@/components/content/HdmSkucomparer').then((mod) => mod.HdmSkucomparer)
	),
	HdmWishlistSidebar: dynamic(() =>
		import('@/components/content/HdmWishlistSidebar').then((mod) => mod.HdmWishlistSidebar)
	),
	HdmWishlistDetail: dynamic(() =>
		import('@/components/content/HdmWishlistDetail').then((mod) => mod.HdmWishlistDetail)
	),
	AccountWelcome: dynamic(() =>
		import('@/components/content/AccountWelcome').then((mod) => mod.AccountWelcome)
	),
	AccountBreadcrumbs: dynamic(() =>
		import('@/components/content/AccountBreadcrumbs').then((mod) => mod.AccountBreadcrumbs)
	),
	BreadcrumbTrail: dynamic(() =>
		import('@/components/content/BreadcrumbTrail').then((mod) => mod.BreadcrumbTrail)
	),
	PaymentMethod: dynamic(() =>
		import('@/components/content/PaymentMethod').then((mod) => mod.PaymentMethod)
	),
	AddPaymentMethod: dynamic(() =>
		import('@/components/content/AddPaymentMethod').then((mod) => mod.AddPaymentMethod)
	),
	CreateCheckoutProfile: dynamic(() =>
		import('@/components/content/CreateCheckoutProfile').then((mod) => mod.CreateCheckoutProfile)
	),
	EditCheckoutProfile: dynamic(() =>
		import('@/components/content/EditCheckoutProfile').then((mod) => mod.EditCheckoutProfile)
	),
	CheckOut: dynamic(() => import('@/components/content/CheckOutV2').then((mod) => mod.CheckOutV2)),
	StaticBreadcrumbTrail: dynamic(() =>
		import('@/components/content/StaticBreadcrumbTrail').then((mod) => mod.StaticBreadcrumbTrail)
	),
	SiteMap: dynamic(() => import('@/components/content/SiteMap').then((mod) => mod.SiteMap)),
	SearchStore: dynamic(() =>
		import('@/components/content/SearchStore').then((mod) => mod.SearchStore)
	),
};
